/* Patagonia Café — rappel multi-produits du panier Shopify sur toute la navigation. */
(function(){
  function init(){
    var banner=document.querySelector('[data-pc-cart-reminder]');
    if(!banner||banner.dataset.ready==='1')return;
    banner.dataset.ready='1';
    var itemsHost=banner.querySelector('[data-pc-cart-items]');
    var countLabel=banner.querySelector('[data-pc-cart-count]');
    var totalLabel=banner.querySelector('[data-pc-cart-total]');
    var deliveryBox=banner.querySelector('[data-pc-delivery-guide]');
    var deliveryMessage=banner.querySelector('[data-pc-delivery-message]');
    var deliveryTrack=banner.querySelector('[data-pc-delivery-track]');
    var deliveryFill=banner.querySelector('[data-pc-delivery-fill]');
    var relayDot=banner.querySelector('[data-pc-delivery-dot-relay]');
    var homeDot=banner.querySelector('[data-pc-delivery-dot-home]');
    var relayLabel=banner.querySelector('[data-pc-delivery-relay]');
    var homeLabel=banner.querySelector('[data-pc-delivery-home]');
    var close=banner.querySelector('[data-pc-cart-dismiss]');
    var dismissed='patagonia-cart-reminder-hidden';
    var latest=0;
    var knownCount=null;
    // pc-cart-adaptive-bottom-space-v1 : le bandeau fixe ne doit jamais recouvrir
    // le pied de page ni le dernier bouton de la page, même avec 3 cafés ou davantage.
    function updateReservedSpace(){
      if(banner.hidden)return;
      var height=Math.ceil(banner.getBoundingClientRect().height);
      if(height>0&&height<800){
        document.documentElement.style.setProperty('--pc-cart-reminder-height',height+'px');
      }
    }
    if(typeof ResizeObserver==='function'){
      new ResizeObserver(function(){updateReservedSpace()}).observe(banner);
    }
    window.addEventListener('resize',updateReservedSpace,{passive:true});
    function getStore(key){try{return window.sessionStorage.getItem(key)}catch(e){return null}}
    function setStore(key,value){try{window.sessionStorage.setItem(key,value)}catch(e){}}
    function euro(cents){return new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR'}).format((Number(cents)||0)/100)}
    function imageUrl(item){
      var value=item.image||(item.featured_image&&item.featured_image.url)||'';
      return typeof value==='string'&&/^(https?:\/\/|\/\/|\/)/i.test(value)?value:'';
    }
    function createLine(item){
      var title=item.product_title||item.title||'Café Patagonia';
      var detail=item.variant_title&&item.variant_title!=='Default Title'?item.variant_title.replace(/\s*\/\s*/g,' · '):'';
      var qty=Number(item.quantity)||1;
      var wrapper=document.createElement('div');
      wrapper.className='pc-cart-reminder__item';
      wrapper.setAttribute('role','listitem');
      wrapper.setAttribute('aria-label',title+', '+(detail?detail+', ':'')+qty+' sachet'+(qty>1?'s':''));
      var picture=document.createElement('span');
      picture.className='pc-cart-reminder__product-picture';
      var url=imageUrl(item);
      if(url){
        var img=document.createElement('img');
        img.src=url;
        img.alt='';
        img.width=39;
        img.height=48;
        img.loading='lazy';
        picture.appendChild(img);
      }else{
        picture.textContent='✦';
      }
      var copy=document.createElement('span');
      copy.className='pc-cart-reminder__item-copy';
      var name=document.createElement('strong');
      name.className='pc-cart-reminder__item-name';
      name.textContent=title;
      var sub=document.createElement('span');
      sub.className='pc-cart-reminder__item-sub';
      sub.textContent=(detail?detail+' · ':'')+'×'+qty;
      copy.appendChild(name);
      copy.appendChild(sub);
      if(item.key){
        var edit=document.createElement('button');
        edit.type='button';
        edit.className='pc-cart-reminder__item-action';
        edit.dataset.pcCartEditKey=String(item.key);
        edit.setAttribute('aria-label','Modifier le format, la quantité ou retirer '+title);
        edit.setAttribute('title','Modifier le format, la quantité ou retirer ce café');
        edit.setAttribute('aria-controls','PCNCartEditor');
        edit.setAttribute('aria-expanded','false');
        edit.appendChild(picture);
        edit.appendChild(copy);
        var glyph=document.createElement('span');
        glyph.className='pc-cart-reminder__edit-icon';
        glyph.textContent='✎';
        glyph.setAttribute('aria-hidden','true');
        edit.appendChild(glyph);
        wrapper.classList.add('pc-cart-reminder__item--editable');
        wrapper.appendChild(edit);
      }else{
        wrapper.appendChild(picture);
        wrapper.appendChild(copy);
      }
      return wrapper;
    }
    // Les seuils sont lus depuis la grille de livraison Patagonia si elle est disponible.
    // Aucune promesse numérique lorsque le panier mélange des contrats différents.
    var coffeeHandles=['sol-andino-sierra-alta','signature-tierra-suave','patagonia-ouro-preto','espresso-brasa-morena','brasil-minas-gerais','colombia-tolima','honduras-la-paz'];
    function coffeeGrams(item){
      var raw=String(item.variant_title||'');
      var match=raw.match(/(?:^|[^0-9])(\d+(?:[.,]\d+)?)\s*(kg|g)(?=$|[^a-z0-9])/i);
      if(match){
        var value=Number(match[1].replace(',','.'))*(match[2].toLowerCase()==='kg'?1000:1);
        if(value>0)return value;
      }
      var saved=Number(item.grams);
      return Number.isFinite(saved)&&saved>0?saved:null;
    }
    function formatWeight(grams){
      if(grams>=1000&&grams%1000===0)return (grams/1000).toLocaleString('fr-FR')+' kg';
      if(grams>=1000&&grams%500===0)return (grams/1000).toLocaleString('fr-FR',{maximumFractionDigits:1})+' kg';
      return grams.toLocaleString('fr-FR')+' g';
    }
    function thresholds(kind){
      var defaultTargets=kind==='subscription'?[1000,1500]:[1500,2000];
      var reference=window.PatagoniaPricing&&window.PatagoniaPricing.reference;
      var grid=reference&&reference[kind];
      if(!grid)return defaultTargets;
      var weights=Object.keys(grid).map(Number).filter(function(n){return Number.isFinite(n)}).sort(function(a,b){return a-b});
      var relay=weights.find(function(w){return Array.isArray(grid[w])&&grid[w][0]===0});
      var home=weights.find(function(w){return Array.isArray(grid[w])&&grid[w][1]===0});
      return [relay||defaultTargets[0],home||defaultTargets[1]];
    }
    function showDelivery(cart){
      if(!deliveryBox||!deliveryMessage||!deliveryTrack)return;
      var items=cart&&Array.isArray(cart.items)?cart.items:[];
      if(!items.length){deliveryBox.hidden=true;return}
      var hasPack=items.some(function(item){return item.handle==='pack-decouverte'});
      var subscriptions=items.filter(function(item){return !!item.selling_plan_allocation||item.handle==='abonnement-cafe'});
      var normal=items.filter(function(item){return !item.selling_plan_allocation&&item.handle!=='abonnement-cafe'&&item.handle!=='pack-decouverte'});
      var recognized=normal.every(function(item){return coffeeHandles.indexOf(item.handle)!==-1});
      var contractMixed=subscriptions.length>0&&normal.length>0;
      var kind=subscriptions.length>0?'subscription':'oneoff';
      var total=0,weightKnown=true;
      (kind==='subscription'?subscriptions:normal).forEach(function(item){
        var w=coffeeGrams(item);
        if(w===null){weightKnown=false;return}
        total+=w*(Number(item.quantity)||1);
      });
      var state='progress', message='', target=2000, relayTarget=1500, homeTarget=2000;
      if(contractMixed||(!recognized&&normal.length)|| (hasPack&&subscriptions.length)){
        state='info';
        message='Livraison selon les formules de votre panier';
      }else if(hasPack){
        state='included';message='Pack Découverte : livraison offerte';total=2000;
      }else if(!weightKnown||total<=0){
        state='info';message='Les frais sont précisés dans votre panier';
      }else{
        var steps=thresholds(kind);
        relayTarget=steps[0];homeTarget=steps[1];target=homeTarget;
        if(total>=homeTarget){
          state='achieved';message='Livraison offerte en relais et à domicile';
        }else if(total>=relayTarget){
          message='Relais offert · Encore '+formatWeight(homeTarget-total)+' pour le domicile';
        }else{
          message='Encore '+formatWeight(relayTarget-total)+' pour le relais offert';
        }
      }
      deliveryBox.dataset.pcDeliveryState=state;
      deliveryMessage.textContent=message;
      deliveryBox.hidden=false;
      if(state==='info'){
        deliveryTrack.removeAttribute('aria-valuenow');
        deliveryTrack.setAttribute('aria-label','Conditions de livraison selon le panier');
        return;
      }
      var max=state==='included'?2000:homeTarget;
      var ratio=Math.min(1,Math.max(0,total/max));
      deliveryTrack.setAttribute('aria-valuemax',String(max));
      deliveryTrack.setAttribute('aria-valuenow',String(Math.min(max,total)));
      deliveryTrack.setAttribute('aria-label','Progression vers la livraison offerte en France métropolitaine');
      deliveryFill.style.width=(ratio*100).toFixed(1)+'%';
      var achievedRelay=state==='included'||total>=relayTarget;
      var achievedHome=state==='included'||total>=homeTarget;
      relayDot.style.left=((state==='included'?0.75:relayTarget/homeTarget)*100).toFixed(1)+'%';
      relayDot.classList.toggle('is-reached',achievedRelay);
      homeDot.classList.toggle('is-reached',achievedHome);
      relayLabel.classList.toggle('is-reached',achievedRelay);
      homeLabel.classList.toggle('is-reached',achievedHome);
      relayLabel.textContent=achievedRelay?'✓ Relais offert':'Relais · '+formatWeight(relayTarget);
      homeLabel.textContent=achievedHome?'✓ Domicile offert':'Domicile · '+formatWeight(homeTarget);
    }
    function hide(){
      banner.hidden=true;
      document.body.classList.remove('pc-cart-has-reminder');
    }
    function display(cart){
      if(!cart||!Array.isArray(cart.items)||cart.item_count<1){knownCount=0;hide();return}
      var currentCount=Number(cart.item_count)||0;
      if(knownCount!==null&&currentCount>knownCount)setStore(dismissed,'0');
      knownCount=currentCount;
      if(getStore(dismissed)==='1'){hide();return}
      var count=cart.items.length;
      // Les 3 cafés et davantage doivent être directement visibles dans le bandeau.
      itemsHost.dataset.pcItemsCount=String(count);
      banner.dataset.pcItemsCount=String(count);
      countLabel.textContent=count+' référence'+(count>1?'s':'')+' · '+cart.item_count+' sachet'+(cart.item_count>1?'s':'');
      totalLabel.textContent=euro(cart.total_price);
      var rows=document.createDocumentFragment();
      cart.items.forEach(function(item){rows.appendChild(createLine(item))});
      itemsHost.replaceChildren(rows);
      showDelivery(cart);
      banner.hidden=false;
      document.body.classList.add('pc-cart-has-reminder');
      window.requestAnimationFrame(updateReservedSpace);
    }
    function refresh(){
      var id=++latest;
      var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      var endpoint=(root.endsWith('/')?root:root+'/')+'cart.js';
      fetch(endpoint,{credentials:'same-origin',headers:{Accept:'application/json'}})
        .then(function(response){if(!response.ok)throw new Error('Cart unavailable');return response.json()})
        .then(function(cart){if(id===latest)display(cart)})
        .catch(function(){if(id===latest)hide()});
    }
    close.addEventListener('click',function(){setStore(dismissed,'1');hide()});
    if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&PUB_SUB_EVENTS.cartUpdate){
      subscribe(PUB_SUB_EVENTS.cartUpdate,function(event){
        if(event&&event.source==='product-form')setStore(dismissed,'0');
        refresh();
      });
    }
    // Le panier Patagonia synchronise toutes les références ici, y compris
    // les ajouts réalisés par ses formulaires AJAX hors événements Shopify natifs.
    document.addEventListener('pcf:cart-updated',function(event){
      var updated=event&&event.detail;
      if(updated&&Array.isArray(updated.items)){
        latest++; // Une ancienne lecture /cart.js ne peut plus écraser l'état récent.
        display(updated);
      }else{
        refresh();
      }
    });
    window.addEventListener('pageshow',function(event){if(event.persisted)refresh()});
    document.addEventListener('visibilitychange',function(){if(!document.hidden)refresh()});
    refresh();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
